export default __webpack_public_path__ + "resources/icons/n600-f04a.png";